import {
  trackClick,
  helloRetailRecommendationKey,
  helloRetailStorefrontProductUrl,
  shopifyAlternateHreflang,
  alternateHrefFromProductHtml,
  productSectionUrlFromProductPageHref,
} from "customHRUtils";

class RecommendedProducts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.key = helloRetailRecommendationKey(this.dataset.key);
    this.sectionSelector = this.dataset.section;
    this.productTemplate = this.dataset.productTemplate;

    this.dom = {
      template: this.getElementsByTagName("template")[0],
      productsConainer: this.getElementsByTagName("template")[0].content.querySelector("[data-products]"),
    };

    if (!this.key || !this.productTemplate || !window.themeVariables.settings.helloRetailId) {
      return;
    }

    document.addEventListener("recoms-loaded", (event) => {
      const response = event.detail.responses.find((response) => response.key == this.key);
      this.init(response);
    });
  }

  addEventListeners(productsInOrder) {
    const scrollContainer = this.querySelector("[data-products]");
    if (!scrollContainer) return;

    Array.from(scrollContainer.children).forEach((productElement, index) => {
      const product = productsInOrder[index];
      if (!product) return;

      productElement.querySelectorAll("a").forEach((productLink) => {
        productLink.addEventListener("click", () => {
          trackClick(product.trackingCode);
        });
      });
    });
  }

  init(response) {
    if (!response) {
      return;
    }

    const products = response.products;

    if (!products || products.length === 0) {
      if (this.sectionSelector) {
        const section = this.closest(this.sectionSelector);
        section.remove();
      }
      return;
    }

    const template = this.getElementsByTagName("template")[0];
    if (!template) {
      return;
    }

    this.dom = {
      template,
      productsConainer: template.content.querySelector("[data-products]"),
    };

    if (!this.dom.productsConainer) {
      return;
    }

    this.dom.productsConainer.replaceChildren();

    const hreflang = shopifyAlternateHreflang();
    const parser = new DOMParser();

    const fetchOne = async (product) => {
      const primaryUrl = `${helloRetailStorefrontProductUrl(product.originalUrl)}?view=${this.productTemplate}`;
      let res = await fetch(primaryUrl);
      if (res.ok) {
        return { product, text: await res.text() };
      }
      if (res.status !== 404 || !hreflang) {
        return null;
      }
      const dkRes = await fetch(product.originalUrl);
      if (!dkRes.ok) {
        return null;
      }
      const html = await dkRes.text();
      const altHref = alternateHrefFromProductHtml(html, hreflang);
      if (!altHref) {
        return null;
      }
      const sectionUrl = productSectionUrlFromProductPageHref(
        altHref,
        this.productTemplate,
        product.originalUrl,
      );
      if (!sectionUrl) {
        return null;
      }
      res = await fetch(sectionUrl);
      if (!res.ok) {
        return null;
      }
      return { product, text: await res.text() };
    };

    Promise.all(products.map(fetchOne)).then((results) => {
      const renderedProducts = [];
      for (const row of results) {
        if (!row) continue;
        renderedProducts.push(row.product);
        const newNode = parser.parseFromString(row.text, "text/html");
        const productTemplateElement = Array.from(newNode.body.children);
        productTemplateElement.forEach((element) => this.dom.productsConainer.appendChild(element));
      }

      this.innerHTML = "";

      const clon = this.dom.template.content.cloneNode(true);
      this.appendChild(clon);

      this.addEventListeners(renderedProducts);
    });
  }
}

if (!customElements.get("recommended-products")) {
  customElements.define("recommended-products", RecommendedProducts);
}
